// ============================================
// 2026-09-14：拖拽数值 HUD 注册表（对齐 Blender 变换中标题栏显示变换程度）
// 拖动 gizmo 时屏幕显示实时坐标/角度/缩放 + 轴锁状态。
// 模块级 DOM 直更（不经 React state）——拖拽高频更新零重渲染（历史教训：拖拽写 store 会引发重渲染风暴）。
// ============================================

export const dragHudRegistry: {
  el: HTMLElement | null;
  show: (text: string) => void;
  hide: () => void;
} = {
  el: null,
  show: (text: string) => {
    if (!dragHudRegistry.el) return;
    dragHudRegistry.el.textContent = text;
    dragHudRegistry.el.style.display = 'block';
  },
  hide: () => {
    if (!dragHudRegistry.el) return;
    dragHudRegistry.el.style.display = 'none';
  },
};
